import type { SchemaNode } from "./schemaEntityGraph";

export const WINNING_PAGE_08_ROUTE = "/blog/chatgpt-modes-explained-work-codex-remote-cloud-guide-2026/";

/** Completes only the source-qualified November 4 workflow guide. */
export function completeWinningPage08Schema(nodes: SchemaNode[], route?: string): SchemaNode[] {
  if (route !== WINNING_PAGE_08_ROUTE) return nodes;
  const graph: SchemaNode[] = JSON.parse(JSON.stringify(nodes));
  const canonical = `https://integrated.social${route}`;
  const article = graph.find(node => node["@id"] === `${canonical}#article`);
  const breadcrumb = graph.find(node => node["@type"] === "BreadcrumbList");
  const faq = graph.find(node => node["@id"] === `${canonical}#faq`);
  if (!article || !breadcrumb) return nodes;

  const commercialTypes = new Set(["Service", "Product", "Offer", "Review", "AggregateRating"]);
  if (Array.isArray(article.about)) article.about = article.about.filter(value =>
    !(value && typeof value === "object" && commercialTypes.has(String((value as SchemaNode)["@type"]))));
  article["@type"] = "BlogPosting";
  delete article.speakable;
  delete article.wordCount; // Shared body-only counter excludes the separately rendered FAQs.
  delete article.abstract; // The unchanged legacy summary includes an unsupported universal taxonomy.
  delete article.hasPart; // Do not repeat that legacy summary as a machine-readable claim.
  article.mentions = [{ "@type": "Organization", name: "OpenAI", url: "https://openai.com/" }];
  if (article.image && typeof article.image === "object" && !Array.isArray(article.image)) {
    article.image = { ...(article.image as SchemaNode), width: 1920, height: 1080 };
  }
  breadcrumb["@id"] = `${canonical}#breadcrumb`;
  article.mainEntityOfPage = { "@id": `${canonical}#webpage` };
  if (faq) faq.isPartOf = { "@id": `${canonical}#webpage` };
  const page: SchemaNode = {
    "@type": "WebPage", "@id": `${canonical}#webpage`, url: canonical,
    name: article.headline, description: article.description, inLanguage: article.inLanguage,
    datePublished: article.datePublished, dateModified: article.dateModified,
    isPartOf: { "@id": "https://integrated.social/#website" },
    mainEntity: { "@id": article["@id"] }, breadcrumb: { "@id": breadcrumb["@id"] },
    primaryImageOfPage: article.image,
    ...(faq ? { hasPart: { "@id": faq["@id"] } } : {}),
  };
  const index = graph.findIndex(node => node["@id"] === page["@id"]);
  if (index === -1) graph.push(page);
  else graph[index] = page;
  return graph;
}
